import { Modal } from 'react-daisyui';
import { Button } from 'components/Button';
import { ProgressBar, Procedures } from 'components/TreatmentPlan'

const TreatmentDetailsModal = ({ isOpen, onClose, treatmentPlan }) => {
  let { title, completed_treatments, treatments } = treatmentPlan || {}
  let { data: treatmentList = [] } = treatments || {}

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      backdrop
      className="max-w-xl rounded-3xl border-none shadow-2xl bg-white p-0 overflow-hidden"
    >
      <Modal.Body className="p-0 pb-6">
        <div className="p-6">
          <h2 className="text-xl font-bold text-secondary-900 leading-tight">Treatment Details</h2>
          <p className="text-xs text-secondary-500 mt-1">Comprehensive {title}</p>
        </div>

        <ProgressBar
          title={'Overall Progress'}
          description={`${completed_treatments} of ${treatmentList.length} completed`}
          percentage={`${treatmentList.length > 0 ? Math.round((completed_treatments / treatmentList.length) * 100) : 0}`}
        />

        <Procedures procedures={treatmentList} />

        <div className="mt-6 px-6">
          <Button
            title="Close"
            onClick={onClose}
            variant="tertiary"
            className="w-full py-3 rounded-2xl"
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TreatmentDetailsModal;
